import SvgSpriteIcon from "@components/SvgSpriteIcon";
import { type ReactElement, type MouseEvent } from "react";
import "./style.css";

export type TTabButtonActionType = (
    event: MouseEvent<HTMLElement>
) => void;

export interface IFileTabButton {
    key: string;
    iconId: string;
    action: TTabButtonActionType;
}
export interface IFileTabButtonsProps {
    onDelete: TTabButtonActionType;
    onRename: TTabButtonActionType;
}

const FileTabButtons = ({
    onDelete,
    onRename,
}: IFileTabButtonsProps): ReactElement => {
    const fileTabButtonsList: IFileTabButton[] = [
        {
            key: "rename",
            iconId: "icon-edit",
            action: onRename,
        },
        {
            key: "delete",
            iconId: "icon-delete",
            action: onDelete,
        },
    ];

    return (
        <div className="file-tab-menu-buttons">
            {fileTabButtonsList.map((fileTabButton: IFileTabButton) => (
                <div
                    className="icon-tab-container"
                    key={fileTabButton.key}
                    onClick={fileTabButton.action}
                >
                    <SvgSpriteIcon
                        className={`menu-icon ${fileTabButton.iconId}`}
                        id={fileTabButton.iconId}
                    />
                </div>
            ))}
        </div>
    );
};

export default FileTabButtons;
